import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance, SingleValueProps} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectComponent, SelectProps} from "@/components/select/Select.types.ts";
import {ServiceVersionDefinition} from "@/lib/types/checks.ts";

const VersionOption = ({data, ...props}: OptionProps<ServiceVersionDefinition>) => {
  return (
    <components.Option {...props} data={data}>
      <div>{data.name}</div>
      <div className={"pulseTextBodyTiny"}>{data.description}</div>
    </components.Option>
  );
};

const SingleValueComponent = ({data, ...props}: SingleValueProps<ServiceVersionDefinition>) => {
  return (
    <components.SingleValue {...props} data={data}>
      {data.name}
    </components.SingleValue>
  );
};

export const VersionSelect = forwardRef(
  (props: SelectProps<ServiceVersionDefinition>, ref: ForwardedRef<SelectInstance<ServiceVersionDefinition>>) => {
    return (
      <Select
        ref={ref}
        components={{
          SingleValue: SingleValueComponent,
          Option: VersionOption,
        }}
        getOptionLabel={(v) => v.name}
        getOptionValue={(v) => v.version.toString()}
        {...props}
      />
    );
  }
) as SelectComponent;
